export default [
    {
        path: '/stage',
        name: 'stages',
        component: () => import('@/views/stage/StagesView.vue'),
        meta: {
            requiresAuth: true
        },
    },
    {
        path: '/stage/:id',
        name: 'stage',
        component: () => import('@/views/stage/StageView.vue'),
        meta: {
            requiresAuth: true
        },
    }
]
